<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-0">
      Step 1: Project Information
    </h2>
    <div class="mb-8 bg-primary-300 py-3 px-5">
      <p class="text-lg font-bold mb-3">
        NEW AWI STANDARDS ALERT!
      </p>
      <p class="mb-2">
        If this project was BID after <strong><em>3/15/2019</em></strong>, unless otherwise specified, the new ANSI/AWI 0620 – 2018 Finish Carpentry/Installation Standards will apply for all Installation.
      </p>
      <p class="mb-2">
        If this project was BID after <strong><em>6/1/2020</em></strong>, unless otherwise specified, BOTH the new ANSI/AWI 0620 – 2018 Finish Carpentry/Installation Standards, AND, the new ANSI/AWI 0641-2019 Architectural Wood Casework Standards will apply for casework Fabrication and all Installation.
      </p>
      <hr class="md:w-1/4">
      <p class="mb-2">
        This will require review of <a href="https://awinet.org/standards/architectural-wood-casework/architectural-wood-casework-introduction/" target="_blank" rel="noopener noreferrer">casework</a> testing requirements.
      </p>
      <p class="mb-2">
        For further information, please see the referenced <a href="https://awinet.org/standards/" target="_blank" rel="noopener noreferrer">Standards available on the AWI website.</a>
      </p>
    </div>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field label="Your Full Name">
        <d-input v-model="submitterName" aria-label="first and last name" required placeholder="First & Last Name" />
      </d-field>
      <d-field label="Your Email">
        <d-input v-model="submitterEmail" aria-label="email" required type="email" placeholder="Email" />
      </d-field>
      <d-field label="QCP Project Number">
        <d-input v-model="qcpProjectNumber" aria-label="project number" required />
      </d-field>
      <d-field label="QCP Contract Amount">
        <d-input v-model="qcpContractAmount" aria-label="contract amount" type="number" required />
      </d-field>
      <d-field label="Project Name">
        <d-input v-model="projectName" aria-label="project name" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Project City" class="w-full md:w-1/2 px-5">
          <d-input v-model="projectCity" aria-label="city" required />
        </d-field>
        <d-field label="Project State/Province" class="w-full md:w-1/2 px-5">
          <d-input v-model="projectStateProvince" aria-label="state/province" required />
        </d-field>
      </div>
      <d-field label="Estimated Completion Date">
        <d-datepicker v-model="estimatedCompletionDate" expanded placeholder="Click to select a date..." icon="calendar" editable />
      </d-field>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CERTIFICATION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('projectCertificationForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['submitterName', 'submitterEmail', 'qcpProjectNumber', 'qcpContractAmount', 'projectName', 'projectCity', 'projectStateProvince', 'estimatedCompletionDate'],
        module: 'projectCertificationForm',
        base: 'formFields',
        mutation: PROJECT_CERTIFICATION_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToNextPage',
      ]),
    },
  };
</script>